/** 天地图 Key / API 根地址（与 index.html、loadTianditu 保持一致） */
export const TIANDITU_TK = 'c3fd2b9b8aa41e4317d3cfe953c59a93'

export const TIANDITU_HOST = 'https://api.tianditu.gov.cn'

export const TIANDITU_JS_SDK_URL = `https://api.tianditu.gov.cn/api?v=4.0&tk=${TIANDITU_TK}`

/** 开发态走 Vite 代理，避免浏览器跨域 */
export function getTiandituApiBase(): string {
  if (import.meta.env.DEV) {
    return '/tianditu-api'
  }
  return TIANDITU_HOST
}
